import * as React from "react";
import { connect } from "react-redux";
import Modal from "../Modal";
import globalAction from '../../actions/global';
import {isPc, getQueryString} from '../../utils/util';
import {} from '../../pages/api';

class PayModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isPcClient: isPc()
        };
    }
    componentDidMount() {
    }
    __onClose() {
        const {onClose, togglePayModal} = this.props;
        togglePayModal(false);
        onClose && onClose();
    }
    __setPayModalData() {

    }
    render() {
        const utm_source = getQueryString('utm_source');
        const {isPayFrameVisible, onPaySuc} = this.props;
        const { isPcClient } = this.state;
        let url = 'https://vpay.vip.163.com/center/index.html?besource=vip_2020618_xf';
        if (!isPc()) {
            url = 'https://vpay.vip.163.com/center/webapp.html?besource=vip_2020618_xf';
        }
        if (utm_source) {
            url += '&utm_source=' + utm_source;
        } else {
            url += '&utm_source=200618';
        }

        window.jumpCallback = function(data) {
            /* status: 0 初始状态|-10 预订单失效|-100 订单失败|50 支付中|100 订单成功|10 已扫码*/
            if (data.status === '100') { 
                // 成功
                onPaySuc && onPaySuc();
            } else if (data.status === '50') {
                alert("支付中，请完成支付后刷新页面");
                window.location.reload();
            } else {
                alert("支付失败");
                window.location.reload();
            }
        }
        return (
            <Modal isOpen={isPayFrameVisible} title="" className="w-pay-modal" onClose={this.__onClose.bind(this)}>
                <div className="w-pay-modal-desc">您未有可用的翻牌次数，续费可得<br/>每个帐号最多可获得2次</div>
                {
                    !isPcClient && <div className="w-pay-modal-actions">
                        <a href={url} className="w-button">前往续费</a>
                    </div>
                }
                {
                    (isPayFrameVisible && isPcClient) && <iframe src={url} frameBorder="0"></iframe>
                }
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    return {
        isPayFrameVisible: state.global.isPayFrameVisible,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        togglePayModal(flag) {
            dispatch(globalAction.togglePayModal(flag));
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PayModal);
